import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';
import { useRouter } from 'next/router';
import { Button, Col, Row } from 'react-bootstrap';
import SectionBox from '../SectionBox/SectionBox';
import { InfoCardStyled } from './InfoCardStyled';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const InfoCard = ({data, title, subTitle}) => {
    const router = useRouter();
    const generateURL = useNavigationURL();

    return (
      <InfoCardStyled>
        <SectionBox>
          <p className="info-card-title">{title}</p>
          <p className="info-card-subtitle">{subTitle}</p>
          <Row className="vertical-col">
            {data?.map((item, index) => (
              <Col key={index} className="mb-3">
                <div className="info-card-parent">
                  <Image
                    src={item?.image}
                    width="548px"
                    height="224px"
                    className="info-card-image"
                    alt={item?.altText}
                    onClick={() => router.push({pathname: generateURL(item?.linkWeb)})}
                  />
                  <div className="info-card-content">
                    <p className="info-card-text">{item?.title}</p>
                    <p className="info-card-subtext">{item?.shortDescription}</p>
                    <Button
                        className="info-card-button btn-sm" 
                        style={{ backgroundColor: item?.buttonColor, borderColor: item?.buttonColor}}
                        onClick={() => router.push({pathname: generateURL(item?.linkWeb)})}
                    >
                        {item?.buttonText}
                    </Button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </SectionBox>
      </InfoCardStyled>
    );
};

InfoCard.propTypes = {
    data: PropTypes.any,
    title: PropTypes.string,
    subTitle: PropTypes.string,
  };
  
InfoCard.defaultProps = {
    data: '',
    title:'',
    subTitle:''
};

export default InfoCard;